import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom'; // Import the hook for getting the current location
import "../styles/navbar.css";

const ColeeNavbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  const location = useLocation(); // Get the current location object

  // Handle scroll effects
  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 50;
      setIsScrolled(scrolled);
      
      const progress = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
      setScrollProgress(Math.min(progress, 100));
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Toggle mobile menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    // Prevent body scroll when menu is open
    document.body.style.overflow = !isMenuOpen ? 'hidden' : '';
  };

  // Close menu on link click (mobile)
  const handleLinkClick = () => {
    if (window.innerWidth <= 768) {
      setIsMenuOpen(false);
      document.body.style.overflow = '';
    }
  };

  // Navigation links data
  const navLinks = [
    { href: '/', label: 'Home' },
    { href: '/about', label: 'About' },
    { href: '/services', label: 'Services' },
    { href: '/industries', label: 'Industries' },
    { href: '/contact', label: 'Contact' }
  ];

  return (
    <>
      {/* Main Navbar */}
      <nav className={`colee-navbar-container fixed-top ${isScrolled ? 'colee-scrolled' : ''}`}>
        
        {/* Background Effects */}
        <div className="colee-nav-particles">
          {[1,2,3,4,5,6].map(i => (
            <div key={i} className={`colee-particle colee-particle-${i}`}></div>
          ))}
        </div>

        {/* Bootstrap Container */}
        <div className="container-fluid">
          <div className="colee-navbar-content d-flex justify-content-between align-items-center">
            
            {/* Logo Section */}
            <a href="/" className="colee-navbar-logo d-flex align-items-center text-decoration-none">
              <div className="colee-logo-container position-relative">
                <div className="colee-logo-glow"></div>
                <div className="colee-logo-scan-line"></div>
              </div>
              <div className="colee-logo-text ms-3">
                <span className="colee-company-name">COLEE</span>
                <span className="colee-company-tagline">Software Services</span>
                <span className="colee-location-tagline">McMinnville, Oregon</span>
              </div>
            </a>

            {/* Desktop Navigation - Bootstrap d-none d-md-flex */}
            <ul className="colee-nav-links d-none d-md-flex list-unstyled mb-0">
              {navLinks.map((link, index) => (
                <li key={index} className="colee-nav-item">
                  <a 
                    href={link.href}
                    className={`colee-nav-link ${location.pathname === link.href ? 'colee-active' : ''}`}
                    onClick={handleLinkClick}
                  >
                    <span className="colee-nav-link-text">{link.label}</span>
                    <div className="colee-nav-link-glow"></div>
                  </a>
                </li>
              ))}
            </ul>

            {/* Mobile Hamburger - Bootstrap d-md-none */}
            <button 
              className={`colee-hamburger-menu d-md-none ${isMenuOpen ? 'colee-active' : ''}`}
              onClick={toggleMenu}
              aria-label="Toggle navigation menu"
              aria-expanded={isMenuOpen}
              type="button"
            >
              <div className="colee-hamburger-glow"></div>
              <div className="colee-hamburger-container">
                <span className="colee-hamburger-line"></span>
                <span className="colee-hamburger-line"></span>
                <span className="colee-hamburger-line"></span>
              </div>
            </button>

          </div>
        </div>

        {/* Scroll Progress */}
        <div className="colee-scroll-progress">
          <div 
            className="colee-progress-bar" 
            style={{ width: `${scrollProgress}%` }}
          ></div>
        </div>

      </nav>

      {/* Mobile Navigation Menu */}
      <div className={`colee-mobile-nav ${isMenuOpen ? 'colee-show' : ''}`}>
        <ul className="colee-mobile-nav-links list-unstyled">
          {navLinks.map((link, index) => (
            <li key={index} className="colee-mobile-nav-item">
              <a 
                href={link.href}
                className={`colee-mobile-nav-link ${location.pathname === link.href ? 'colee-active' : ''}`}
                onClick={handleLinkClick}
                style={{ '--colee-delay': `${index * 0.1}s` }}
              >
                <span className="colee-nav-link-text">{link.label}</span>
                <div className="colee-nav-link-glow"></div>
              </a>
            </li>
          ))}
          
          {/* Mobile CTA */}
          <li className="colee-mobile-nav-item colee-mobile-cta">
            <a href="/get-started" className="colee-cta-button">
              Get Started
            </a>
          </li>
        </ul>
      </div>

      {/* Mobile Backdrop */}
      {isMenuOpen && (
        <div 
          className="colee-nav-backdrop"
          onClick={toggleMenu}
        ></div>
      )}
    </>
  );
};

export default ColeeNavbar;
